<template>
  <div>
    <!-- Common error message -->
    <div v-if="error">
      <div class="alert alert-danger text-center">
        {{ error }}
      </div>
    </div>

    <div class="text-right">
      <button class="btn btn-success btn-outline btn-sm" @click="$modal.show('addSignatureModal');">
        <i class="fa fa-fw fa-plus"></i> Add a signature
      </button>
    </div>
    <email-signature-form
      modal-id="addSignatureModal"
      title="Add Email signature"
    ></email-signature-form>

    <div v-if="signaturesLoading" class="text-center">
      <!-- Loading indicator -->
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
    <div v-else>

      <!-- Signature list -->
      <div v-if="signatures.length" class="table-responsive">
        <table class="table m-b-xs m-t-xs">

          <thead>
          <tr>
            <th>Email</th>
            <th>Signature</th>
            <th class="text-right col-md-1 col-sm-2 col-xs-2">Action</th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="(item, index) in signatures">
            <td>{{ item.email }}</td>
            <td>
              <div v-html="item.signature"></div>
            </td>

            <td class="text-right">
              <div class="btn-group btn-group-sm">
                <button class="btn btn-primary" @click="$modal.show('signatureEdit' + index);"><i
                  class="fa fa-pencil"></i> Edit
                </button>

                <div class="btn-group btn-group-sm">
                  <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"
                          aria-haspopup="true" aria-expanded="false">
                    <span class="caret"></span>
                  </button>
                  <div class="dropdown-menu">
                    <a class="dropdown-item" href="#" @click="confirmDeleteSignature(item)">Delete signature</a>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <!-- Signature modals -->
        <div v-for="(signature, index) in signatures">
          <email-signature-form :modal-id="'signatureEdit' + index"
                                title="Edit Email signature"
                                :signature-id="parseInt(signature.id)"
                                :initial-signature="signature"
          ></email-signature-form>
        </div>
      </div>

      <div v-else>
        <div class="alert alert-info text-center m-t-xs m-b-xs">
          No email signatures.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmailSignatureForm from "./EmailSignatureForm.vue";

export default {

  /**
   * Used components
   */
  components: {
    EmailSignatureForm
  },

  /**
   * Variables (models).
   */
  data() {
    return {

      // Signature list.
      signatures: [],

      // Common error message.
      error: '',

      // Signature loading indicator.
      signaturesLoading: false,
    }
  },

  /**
   * Functions (methods).
   */
  methods: {

    /**
     * Init component.
     */
    init() {
      // Initial load signatures.
      this.loadSignatures();
    },

    /**
     * Load signatures.
     */
    loadSignatures() {
      this.signaturesLoading = true;
      axios.get('/admin/system-utilities/email-signature/list')
        .then(response => {
          this.signatures = response.data;
        })
        .catch(error => {
          this.handleErrors(error, 'Unable to load signatures.')
        })
        .then(() => {
          this.signaturesLoading = false;
        });
    },

    /**
     * Delete signature dialog.
     */
    confirmDeleteSignature(signature) {
      this.$swal.fire({
        title: 'Delete email signature',
        text: 'You are about to delete email signature. This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete'
      }).then((result) => {
        if (result.value) {
          this.deleteSignature(signature);
        }
      })
    },

    /**
     * Delete signature.
     */
    deleteSignature(signature) {
      const formData = new FormData();
      formData.append('_method', "DELETE");
      axios.post('/admin/system-utilities/email-signature/' + signature.id, formData)
        .then(response => {
          this.$swal.fire(
            'Deleted',
            'The email signature has been deleted.',
            'success'
          );
          this.loadSignatures();
        })
        .catch(error => {
          this.handleErrors(error, 'Unable to remove signature')
        });
    },

    /**
     * Handle axios errors
     *
     * @param errorObj
     * @param defaultSignature
     */
    handleErrors(errorObj, defaultSignature) {
      if (errorObj.response.status === 403) {
        this.error = defaultSignature + ': access denied.';
      } else {
        this.error = defaultSignature;
      }
    },
  },

  /**
   * Initialize component on mount.
   */
  mounted() {
    this.init();
  }

}
</script>

<style>
table p {
  margin-bottom: 0;
}
</style>
